/* Parwin trust-icon popups: tap a buy-box trust icon to see brief terms + a link to the policy. */
(function () {
  if (window.__ppUspPopup) return; window.__ppUspPopup = true;

  var DATA = {
    delivery: { title: 'Free UK Delivery over £30',
      body: 'Free standard delivery on UK orders over £30 (£2.99 below that), dispatched via tracked couriers so you can follow your parcel to the door. Need it sooner? Express delivery is also available at checkout for faster, next-day shipping.',
      link: '/policies/shipping-policy', linkText: 'Read our Shipping Policy' },
    warranty: { title: '1-Year Warranty',
      body: 'Every tool bought directly from parwinbeauty.co.uk is covered by a 12-month warranty against manufacturing faults. Buy direct to stay protected. Units from third-party resellers are not covered.',
      link: '/pages/12-months-warranty', linkText: 'See warranty details' },
    returns: { title: '30-Day Returns',
      body: 'Changed your mind? You have 30 days from delivery to request a return. Items should be unused and in their original packaging, with proof of purchase. Contact us and we’ll send you a return label.',
      link: '/policies/refund-policy', linkText: 'Read our Refund Policy' },
    guarantee: { title: '30-Day Money-Back Guarantee',
      body: 'Shop with confidence. If a tool isn’t right for you, return it within 30 days of delivery for a refund of the product price, subject to our returns conditions.',
      link: '/policies/refund-policy', linkText: 'Read our Refund Policy' }
  };
  function keyFor(txt){
    txt = (txt || '').toLowerCase();
    if (txt.indexOf('deliver') > -1 || txt.indexOf('shipping') > -1) return 'delivery';
    if (txt.indexOf('warrant') > -1) return 'warranty';
    if (txt.indexOf('money') > -1 || txt.indexOf('guarantee') > -1) return 'guarantee';
    if (txt.indexOf('return') > -1) return 'returns';
    return null;
  }

  var CSS = ''
  + '.ai-icon-text-price__feature-ar1hamu9zovrkzvh2waigenblockb3b850ci4l94p,[class*="ai-icon-text-price__feature-"]{cursor:pointer}'
  + '.ppop{position:fixed;inset:0;z-index:99998;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.5)}'
  + '.ppop.is-open{display:flex}'
  + '.ppop__card{background:#fff;border-radius:14px;max-width:420px;width:100%;padding:22px 22px 20px;position:relative;box-shadow:0 12px 40px rgba(0,0,0,.25);animation:ppop-in .16s ease}'
  + '@keyframes ppop-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}'
  + '.ppop__close{position:absolute;top:10px;right:12px;border:0;background:none;font-size:26px;line-height:1;color:#8a8a8a;cursor:pointer;padding:2px 6px}'
  + '.ppop__close:hover{color:#1a1a1a}'
  + '.ppop__title{font-size:1.15rem;font-weight:700;color:#1a1a1a;margin:0 26px 10px 0}'
  + '.ppop__body{font-size:.95rem;line-height:1.55;color:#4a4a4a;margin:0 0 16px}'
  + '.ppop__link{display:inline-flex;align-items:center;gap:6px;font-weight:700;color:#d81e1e;text-decoration:none;font-size:.95rem}'
  + '.ppop__link:hover{text-decoration:underline}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  var pop;
  function build(){
    if (pop) return;
    pop = document.createElement('div'); pop.className = 'ppop'; pop.setAttribute('role','dialog'); pop.setAttribute('aria-modal','true');
    pop.innerHTML = '<div class="ppop__card"><button class="ppop__close" aria-label="Close">&times;</button>'
      + '<h3 class="ppop__title"></h3><p class="ppop__body"></p>'
      + '<a class="ppop__link" href="#"><span class="ppop__linktext"></span> &rarr;</a></div>';
    document.body.appendChild(pop);
    pop.querySelector('.ppop__close').addEventListener('click', close);
    pop.addEventListener('click', function(e){ if (e.target === pop) close(); }); // backdrop
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
  }
  function open(d){
    build();
    pop.querySelector('.ppop__title').textContent = d.title;
    pop.querySelector('.ppop__body').textContent = d.body;
    var a = pop.querySelector('.ppop__link'); a.href = d.link; pop.querySelector('.ppop__linktext').textContent = d.linkText;
    pop.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    pop.querySelector('.ppop__close').focus();
  }
  function close(){ if (pop){ pop.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }

  document.addEventListener('click', function(e){
    var f = e.target && e.target.closest && e.target.closest('[class*="ai-icon-text-price__feature-"]');
    if (!f) return;
    var k = keyFor(f.textContent);
    if (!k || !DATA[k]) return;
    e.preventDefault(); e.stopPropagation();
    open(DATA[k]);
  });
})();
